

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import SearchFilters from '@/components/search/SearchFilters.vue';
import { SearchFilters as storeFilters } from '@/store/modules/searchInterfaces';
import SearchSorting from '@/components/search/SearchSorting.vue';
import SmallSearchResult from '@/components/search/SmallSearchResult.vue';
import SearchPagination from '@/components/search/SearchPagination.vue';
import { UserSearchRequest } from '@/store/modules/commonInterfaces';
import { CommonModule } from '@/store/modules/common';
import { User } from '@/store/modules/auth';
import { SearchModule } from '@/store/modules/search';

@Component({
  components: {
    SearchFilters,
    SearchSorting,
    SmallSearchResult,
    SearchPagination
  }
})
export default class AssociatedProcesses extends Vue {
  get filters() {
    return SearchModule.filters;
  }

  get result() {
    return SearchModule.result;
  }

  get key() {
    return SearchModule.filters.page * SearchModule.filters.size;
  }

  updateFilters(filters: SearchFilters) {
    return SearchModule.assignFilters({
      page: 0,
      ...filters
    });
  }

  assignFilters(filters: SearchFilters) {
    SearchModule.assignFilters({
      page: 0,
      ...filters
    });
  }

  add(process: any) {
    this.$emit('add', process);
  }
}
